import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { UNKNOWN_COMPONENT } from '../constants';
import { ErrorMonitorBoundary, } from './ErrorMonitorBoundary';
export const withErrorMonitorBoundary = (WrappedComponent, options) => {
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;
    const Wrapped = (props) => (React.createElement(ErrorMonitorBoundary, { ...options },
        React.createElement(WrappedComponent, { ...props })));
    Wrapped.displayName = `errorMonitorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    hoistNonReactStatics(Wrapped, WrappedComponent);
    return Wrapped;
};
//# sourceMappingURL=withErrorMonitorBoundary.js.map